"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const classnames_1 = require("classnames");
const NoOutlinedInput_styles_1 = require("./NoOutlinedInput.styles");
const VisaLogoIcon_1 = require("../../assets/icons/VisaLogoIcon");
const MasterCardLogoIcon_1 = require("../../assets/icons/MasterCardLogoIcon");
const AmericanExpressLogoIcon_1 = require("../../assets/icons/AmericanExpressLogoIcon");
const NoOutlinedInput = (_a) => {
    var { submitted, placeholder, disabled, hasCardLogos, required, value, error, errorText, ref, sx, name, onBlur, onFocus, onChange } = _a, rest = __rest(_a, ["submitted", "placeholder", "disabled", "hasCardLogos", "required", "value", "error", "errorText", "ref", "sx", "name", "onBlur", "onFocus", "onChange"]);
    const [val, setVal] = (0, react_1.useState)(value || '');
    const [err, setErr] = (0, react_1.useState)(error || false);
    const [touched, setTouched] = (0, react_1.useState)(false);
    const { errorTextStyles } = (0, NoOutlinedInput_styles_1.default)();
    const handleChange = (e) => {
        setVal(e.target.value);
        if (onChange) {
            onChange(e);
        }
    };
    const handleBlur = (e) => {
        setTouched(true);
        if (onBlur) {
            onBlur(e);
        }
    };
    const handleFocus = (e) => {
        if (onFocus) {
            onFocus(e);
        }
    };
    (0, react_1.useEffect)(() => {
        if (submitted && required) {
            setErr(!val);
        }
    }, [submitted]);
    (0, react_1.useEffect)(() => {
        if (touched && required) {
            setErr(!val);
        }
    }, [val, touched, required]);
    (0, react_1.useEffect)(() => {
        if (value) {
            setVal(value);
        }
    }, [value]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: Object.assign({}, (sx || {})), children: [(0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({}, rest, { className: (0, classnames_1.default)({
                    valid: val,
                    nonOutlined: true,
                }), variant: "outlined", name: name, fullWidth: true, InputProps: {
                    endAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { sx: {
                            '& .MuiSvgIcon-root': {
                                width: '32px',
                                height: '32px',
                            },
                            gap: '8px',
                        }, position: "end", children: hasCardLogos && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(VisaLogoIcon_1.default, { fontSize: "large" }), (0, jsx_runtime_1.jsx)(MasterCardLogoIcon_1.default, { fontSize: "large" }), (0, jsx_runtime_1.jsx)(AmericanExpressLogoIcon_1.default, { fontSize: "large" })] })) })),
                }, error: (touched && err) || !!error, disabled: disabled, placeholder: placeholder || 'Please enter value', inputRef: ref, inputProps: {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    onFocus: handleFocus,
                }, value: value })), err && (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: errorTextStyles, children: (errorText === null || errorText === void 0 ? void 0 : errorText.required) || 'Required field' }), touched && !err && error && ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: errorTextStyles, children: (errorText === null || errorText === void 0 ? void 0 : errorText.invalid) || 'Invalid value' }))] }));
};
exports.default = NoOutlinedInput;
